module.exports = __webpack_public_path__ + "img/heat-radio.0c1bfc30.png";